module.exports = "/virtual-football/img/video/result-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/result-logo.png
// module id = 1984
// module chunks = 6